"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_cool_img_1 = __importDefault(require("react-cool-img"));
var loading_gif_1 = __importDefault(require("./loading.gif"));
var index_1 = require("../index");
var Thumbnail = function (props) {
    var id = props.id, handleClickEvent = props.handleClickEvent;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { onClick: function () { return handleClickEvent(id); } },
            react_1.default.createElement(react_cool_img_1.default, { src: index_1.getImageUrl(id), placeholder: loading_gif_1.default }))));
};
exports.default = Thumbnail;
